<template>
  <div>
    <label>
      <slot name="label"></slot>
      &nbsp;- {{ timeScale }}
    </label>
    <div class="row">
      <div class="input-col">
        <num-input
          v-model="inputVal"
          :valid="valid"
          focus="off"
          :showError="showError"
        ></num-input>
      </div>
      <div class="switch-col">
        <app-switch v-model="switchVal"></app-switch>
      </div>
    </div>
  </div>
</template>

<script>
import singleNumericInput from "./SingleNumericInput.vue";
import minSecSwitch from "./minSecSwitch.vue";

export default {
  components: {
    "num-input": singleNumericInput,
    "app-switch": minSecSwitch,
  },
  props: ["value", "isInSeconds", "valid", "showError", "errorMessage"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    switchVal: {
      get() {
        return this.isInSeconds;
      },
      set(val) {
        this.$emit("clicked", val);
      },
    },
    timeScale() {
      return this.isInSeconds ? this.$i18n.t('message.misc.inSeconds') : this.$i18n.t('message.misc.inMinutes');
    },
  },
};
</script>

<style scoped>
.input-col {
  flex-grow: 3;
}

.switch-col {
  flex-grow: 0;
}

@media only screen and (max-width: 768px) {
  .row {
    flex-direction: column;
    align-items: flex-start;
  }

  .input-col {
    width: 100%;
  }
}
</style>
